import { createI18n } from 'vue-i18n';
import envConfig from '@/helpers/envConfig';
import messages from '@intlify/unplugin-vue-i18n/messages'

const setDateTimeFormats = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
  },
};

const dateTimeFormats = {
  en: setDateTimeFormats,
  es: setDateTimeFormats,
  de: setDateTimeFormats,
  'en-GB': setDateTimeFormats,
};

const instance = createI18n({
  locale: envConfig.VUE_APP_I18N_LOCALE || 'ru',
  fallbackLocale: 'ru',
  messages,
  legacy: false,
  dateTimeFormats,
});

export default instance;

export const i18n = instance.global;